const CALENDLY_ORIGIN = "https://calendly.com";

/**
 * Whether a `message` event is the Calendly embed reporting a booked meeting.
 * Only messages from calendly.com count, so no other frame can fake a booking.
 */
export function isCalendlyEventScheduled(
	event: Pick<MessageEvent, "origin" | "data">,
): boolean {
	if (event.origin !== CALENDLY_ORIGIN) {
		return false;
	}

	const data: unknown = event.data;
	return (
		typeof data === "object" &&
		data !== null &&
		(data as { event?: unknown }).event === "calendly.event_scheduled"
	);
}
